import { SlackNotificationsSettings } from '../../shared/types/types';

const defaultSlackNotifications: SlackNotificationsSettings = {
  meetingStartsSoon: false,
  mentionedInNotes: false,
  taskOverdue: false,
  taskCreated: false,
  taskUpdated: false,
  taskDeleted: false,
};

export default defaultSlackNotifications;
